import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar } from 'react-bootstrap';
import config from './config.json';

const Step2 = ({ prevStep, nextStep, setStep }) => {
const currentStep = 2;
 
  const [construction_date, setConstructionDate] = useState(''); 

  useEffect(() => {
    // Récupère la valeur du localStorage lors du chargement initial du composant
    const storedValue = localStorage.getItem('construction_date');
    if (storedValue) {
      setConstructionDate(storedValue);
    }
  }, []);

  const handleChange = (event) => {
    const { value } = event.target;
    setConstructionDate(value);
    localStorage.setItem('construction_date', value);
    nextStep();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validation et logique supplémentaire ici

    // Si la réponse est "moins de 2 ans", passez à l'étape souhaitée
    if (construction_date === 'moins_de_2_ans') {
        // Remplacez "x" par le numéro de l'étape vers laquelle vous souhaitez rediriger
        setStep(99);
    } else {
        nextStep();
    }
  };

  return (
    <Container>
      <ProgressBar
        now={(currentStep / config.totalSteps) * 100}
        style={{ backgroundColor: "#bad7f1" }}
      >
      <ProgressBar
        now={(currentStep / config.totalSteps) * 100}
        style={{ backgroundColor: "#0be288" }}
      />
      </ProgressBar>
      <Form onSubmit={handleSubmit}>  
        <Row className="mb-3">
          <Col>
              <h2>{config.step2.step}</h2>
              <h3>{config.step2.title}</h3>
          </Col>
        </Row>
        <Row className="mb-3 justify-content-center">
          {[
            { label: 'Moins de 2 ans', value: 'moins_de_2_ans', image: `${config.linkImage}${config.step2.image1}` },
            { label: 'Entre 2 et 15 ans', value: 'entre_2_et_15_ans', image: `${config.linkImage}${config.step2.image2}` },
            { label: 'Plus de 15 ans', value: 'plus_de_15_ans', image: `${config.linkImage}${config.step2.image3}` },
          ].map(({ label, value, image }, index) => (
            <Col key={index} className={`m-2 icon-container ${construction_date === value ? 'selected' : ''}`}>
                <label className="construction-date-label">
                  <input
                    type="radio"
                    value={value}
                    checked={construction_date === value}
                    onChange={handleChange}
                    className="d-none"
                  />
                   <div>
                    <img src={image} className="size-img" />
                    <p>{label}</p>
                   </div> 
                </label>
            </Col>
          ))}
        </Row>
        <Row className="mt-3">
          <Col className="d-flex justify-content-between">
            <Button type="button" variant="secondary" onClick={prevStep}>
              Précédent
            </Button>
            <Button type="submit" variant="primary" className="ms-3" disabled={!construction_date ? true : false}>
              Suivant
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default Step2;